const enLocale = require('./en.js')
const zhCNLocale = require('./zhCN.js')
const esLocale = require('./es.js')
const jaLocale = require('./ja.js')

const $messages = {
    en: {
        ...enLocale
    },
    zhCN: {
        ...zhCNLocale
    },
    es: {
        ...esLocale
    },
    ja: {
        ...jaLocale
    }
}

// export const messages = $messages

module.exports = {
    ...$messages
}
